import Http from '@/ship/Http';
import { GetRequestParams } from '@/ship/Requests/RequestParams';

export const createAnnualConstructionReport = (id: number, data: any, params?: GetRequestParams) => {
    return Http.post(`/project-management/charts/${id}/report`, data, { params });
};
